import React, {useState, useEffect} from 'react';
import Jumbotron from '../components/jumbotron/index';
import jumboData from '../fixtures/jumbo';
import Button from '../components/ui-elements/buttons/index';
import { SubTitle1 } from '../typography/typography';
import {Fade, Slide} from 'react-reveal';

export default function JumbotronContainer({params}) {
  console.log(params);
  const [projects, setProjects] = useState([]);

  useEffect(() => {

    const {type} = params;

    switch (type) {
      case "webapplicationdevelopment":
            setProjects(jumboData[0]["projects"])
          break;
      case "androidapplicationdevelopment":
            setProjects(jumboData[1]["projects"])
          break;
      case "c++programming":
            setProjects(jumboData[2]["projects"])
          break;  
      case "machinelearning":
            setProjects(jumboData[3]["projects"])
          break;      
      case "dataanalysis":
            setProjects(jumboData[4]["projects"])
          break;        
      default:
            setProjects(jumboData[0]["projects"])
          break;
  }
  }, [projects,params]);

  return (
      <Jumbotron.Container>
        {projects? projects.map((item)=> (
            <div style={{position:"relative"}}>
          <Jumbotron 
          key={item.id}
          direction={item.direction}>
              <Jumbotron.Pane>
                <Jumbotron.Title>{item.title}</Jumbotron.Title>
                <Slide left ={item.direction === "row"} right = {item.direction === "row-reverse"}>
                  <SubTitle1>{item.stack}</SubTitle1>
                  <Jumbotron.SubTitle>{item.subTitle}</Jumbotron.SubTitle>
                </Slide>
              </Jumbotron.Pane>
            <Jumbotron.Pane>
              <Fade>
                <Jumbotron.Image src={item.image} alt={item.alt} />
              </Fade>
            </Jumbotron.Pane>
          </Jumbotron>
            <a href={item.link} target="_blank" rel="noreferrer">
            <Button style={{position: "absolute", bottom: "-2%", left: "50%", transform: "translateX(-50%)"}}>
                <Button.Button>
                    EXPLORE
                </Button.Button>
            </Button>
            </a>
            </div>
        )) : "Loading..."}
    
      </Jumbotron.Container>
  );
}

